import * as React from "react";
import PaymentLayout from "../layout/paymentLayout";
import Feedback from "./feedback";


const withLayout = (Component: React.Element) => function LayoutWrapper(props: any) {
    return (
        <PaymentLayout>
            <Component {...props} />
        </PaymentLayout>
    );
};

export default {
    Feedback: withLayout(Feedback),
};